/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getTickerUiSettings } from '../fn/ticker-ui-settings/get-ticker-ui-settings';
import { GetTickerUiSettings$Params } from '../fn/ticker-ui-settings/get-ticker-ui-settings';
import { setTickerUiSettings } from '../fn/ticker-ui-settings/set-ticker-ui-settings';
import { SetTickerUiSettings$Params } from '../fn/ticker-ui-settings/set-ticker-ui-settings';
import { TickerUiSettingsDto } from '../models/ticker-ui-settings-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedTickerUiSettingsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTickerUiSettings()` */
  static readonly GetTickerUiSettingsPath = '/api/ticker-ui-settings';

  /**
   * Gets the current ticker ui settings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTickerUiSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickerUiSettings$Response(params?: GetTickerUiSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<TickerUiSettingsDto>> {
    return getTickerUiSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the current ticker ui settings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTickerUiSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickerUiSettings(params?: GetTickerUiSettings$Params, context?: HttpContext): Observable<TickerUiSettingsDto> {
    return this.getTickerUiSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<TickerUiSettingsDto>): TickerUiSettingsDto => r.body)
    );
  }

  /** Path part for operation `setTickerUiSettings()` */
  static readonly SetTickerUiSettingsPath = '/api/ticker-ui-settings';

  /**
   * Sets the current ticker ui settings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setTickerUiSettings()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setTickerUiSettings$Response(params: SetTickerUiSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setTickerUiSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * Sets the current ticker ui settings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setTickerUiSettings$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setTickerUiSettings(params: SetTickerUiSettings$Params, context?: HttpContext): Observable<void> {
    return this.setTickerUiSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
